<template>
  <div class="loginWrap registerWrap">
    <header class="login-header">
      <div class="brand">
        <span class="brand-mark">
          <img :src="brandLogo" alt="" />
        </span>
        <span class="brand-name">{{ $t("brand.name") }}</span>
      </div>
      <LanguageSwitch />
    </header>
    <div class="login-main">
      <section class="login-card">
        <div class="tabs">
          <div class="loginMethod activeMethod">
            <div>{{ $t("register.title") }}</div>
            <div class="line"/>
          </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent="submit">
          <el-form-item prop="phone">
            <el-input v-model="form.phone" :placeholder="$t('register.phone')" />
          </el-form-item>
          <el-form-item prop="sms_code">
            <el-input v-model="form.sms_code" :placeholder="$t('register.sms')">
              <el-button slot="append" type="primary" @click="sendCode">
                {{ showTimeCount ? `${timeCount}${$t("register.seconds")}` : $t("register.sendCode") }}
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" show-password :placeholder="$t('register.password')" />
          </el-form-item>
          <el-form-item prop="confirm_password">
            <el-input v-model="form.confirm_password" show-password :placeholder="$t('register.confirm')" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="loginBtn" native-type="submit">{{ $t("register.submit") }}</el-button>
          </el-form-item>
        </el-form>
        <div class="login-extra">
          <a @click="$router.push('/login')">{{ $t("register.hasAccount") }}</a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import brandLogo from '@/assets/logo-main-new.png';
import { setCookie } from '@/utils/utils';
import { isNeedChangePassword } from '@/utils/account';
import '@/views/Login/index.scss';

export default {
  components: { LanguageSwitch },
  data() {
    return {
      brandLogo,
      form: {
        phone: "",
        sms_code: "",
        password: "",
        confirm_password: "",
      },
      showTimeCount: false,
      timeCount: 60,
    };
  },
  computed: {
    rules() {
      const confirm = (rule, value, callback) => {
        if (value !== this.form.password) {
          callback(new Error(this.$t("register.mismatch")));
        } else {
          callback();
        }
      };
      return {
        phone: [{ required: true, message: this.$t("register.phone"), trigger: "blur" }],
        sms_code: [{ required: true, message: this.$t("register.sms"), trigger: "blur" }],
        password: [
          { required: true, message: this.$t("register.setPassword"), trigger: "blur" },
          { min: 6, message: this.$t("register.min6"), trigger: "blur" },
        ],
        confirm_password: [
          { required: true, message: this.$t("register.confirm"), trigger: "blur" },
          { validator: confirm, trigger: "blur" },
        ],
      };
    },
  },
  methods: {
    sendCode() {
      if (this.showTimeCount) return;
      this.$request.getLoginVerifyCode({ phone: this.form.phone }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.showTimeCount = true;
        this.timer = setInterval(() => {
          if (this.timeCount <= 0) {
            clearInterval(this.timer);
            this.showTimeCount = false;
            this.timeCount = 60;
            return;
          }
          this.timeCount -= 1;
        }, 1000);
        this.$message.success(this.$t("common.sendSuccess"));
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$request
          .registerUser({
            phone: this.form.phone,
            sms_code: this.form.sms_code,
            password: this.form.password,
            confirm_password: this.form.confirm_password,
          })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            const data = res.data || {};
            this.$store.commit("setLoginAccountInfo", data);
            setCookie("loginAccountInfo", JSON.stringify(data), 7 * 24 * 60 * 60 * 1000);
            if (isNeedChangePassword(data)) {
              this.$router.push("/personal");
              return;
            }
            this.$request.getUserAuthorizedMenus({ user_id: data.user_id }).then((menuRes) => {
              if (menuRes.status != "success") {
                this.$router.push("/homePage");
                return;
              }
              this.$store.commit("setAuthorizedMenus", {
                data: menuRes?.data?.children || [],
              });
            });
          });
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
